import React from 'react';
import PropTypes from 'prop-types';
import { TitleSet } from '@flightstats/component-lib';

const mainText = (params) => {
  const { carrierCode, airlineName, flightNumber } = params;
  const carrierText = carrierCode ? `(${carrierCode})` : '';
  return `${carrierText} ${airlineName || ''} ${flightNumber || ''} On-time Performance Rating`;
};

const Header = ({ params }) => {
  const titleText = params ? mainText(params) : 'On-time Performance Rating';

  return <TitleSet mainText={titleText} />;
};

Header.propTypes = {
  params: PropTypes.object,
};

export default Header;



// WEBPACK FOOTER //
// ./modules/OnTimePerformance/components/shared/Header/Header.js